import { Outlet, Route, Routes } from "react-router-dom";
import CheckSystem from "./ExamComponent/CheckSystem";
import ProtectedComponent from "./ExamRoom/ProtectedScreen";
import ScreenShare from "./ExamRoom/CheatingDetection/ScreenShare";
import SecurityWrapper from "./ExamRoom/CheatingDetection/SecurityWrapper";
import FullscreenValidator from "./ExamRoom/CheatingDetection/FullScreenValidator";
import InspectValidator from "./ExamRoom/CheatingDetection/InspectValidator";
import { useState } from "react";
import { examConfig } from "../../config/examConfig";

const OnlineExamRoutes = () => {
    const [camera, setCamera] = useState(false);
    const [face, setFace] = useState({ faceDetected: false, singleFace: false });
    const [isReload, setIsReload] = useState(false);

    const routes = (
        <Routes>
            <Route path="/system-check" element={<CheckSystem
                onReload={() => setIsReload(true)}
                camera={examConfig.enableCheatingDetection ? camera : true}
                face={examConfig.enableCheatingDetection ? face : { faceDetected: true, singleFace: true }} />}
            />
            <Route path="/exam" element={<ProtectedComponent />} />
        </Routes>
    );

    if (examConfig.enableCheatingDetection) {
        return (
            <>
                <ScreenShare
                    onFaceResult={(face) => {
                        setFace({ faceDetected: face.faceDetected, singleFace: face.singleFace });
                    }}
                    onCameraStart={(camera) => {
                        setCamera(camera);
                    }}
                    reload={isReload}
                >
                    <SecurityWrapper>
                        <FullscreenValidator>
                            <InspectValidator>
                                {routes}
                            </InspectValidator>
                        </FullscreenValidator>
                    </SecurityWrapper>
                </ScreenShare>
            </>
        );
    }

    return <>{routes}</>;
}

export default OnlineExamRoutes;